import { Query } from "@com.mgmtp.a12.dataservices/dataservices-access";

import { OpenDocumentPayload } from "../modules/processOverview/store/actions";
import { isDocumentWithIdAndProcessMetadata } from "../modules/workflows/data/processMetadata";

import { query } from "./rpcHelper";
import { DocumentWithPermission } from "./workflowUtils";

import QueryRoot = Query.QueryRoot;

export async function createOpenTaskDocumentPayloadFromProcessInstanceId(
	documentWithPermission: DocumentWithPermission,
	initiatingActivityId?: string
): Promise<OpenDocumentPayload | undefined> {
	const { docSpec, hasPermission } = documentWithPermission;
	const document = { ...docSpec.document, id: docSpec.docRef, modelId: docSpec.documentModelName };

	if (!isDocumentWithIdAndProcessMetadata(document)) {
		return;
	}

	return {
		instance: document.id,
		document,
		initiatingActivityId,
		hasTaskPermission: hasPermission !== undefined ? { isLoaded: true, hasPermission } : { isLoaded: false }
	};
}

export async function createOpenTaskDocumentPayloadFromProcessInstanceIdV2(
	processId: string,
	modelName: string,
	initiatingActivityId?: string
): Promise<OpenDocumentPayload | undefined> {
	const queryRoot: QueryRoot = {
		projectionName: "document",
		targetDocumentModel: modelName,
		paging: { pageNumber: 0, pageSize: 10 },
		constraint: {
			operator: "exact_match",
			field: "/root/processMetadata/processId",
			value: processId
		}
	};

	const results = await query(queryRoot);

	if (!results || results.length === 0) {
		return;
	}

	const result = results[0];

	const document = { ...result.document, id: result.docRef, modelId: result.documentModelName };

	if (!isDocumentWithIdAndProcessMetadata(document)) {
		return;
	}

	return {
		instance: document.id,
		document,
		initiatingActivityId
	};
}
